// AUTO-GENERATED by scripts/gen-config.js from Terraform outputs.
// Do NOT edit by hand. Regenerate with: npm run gen-config
// Business terminology lives in ./terminology.js and is preserved across runs.
import terminology from './terminology';

const config = {
  userPoolId: "us-east-1_0bu5fyGOz",
  userPoolWebClientId: "7iblv9soch10p8vnstgfp5n608",
  cognitoDomain: "https://blackcap-aa3a8a8b.auth.us-east-1.amazoncognito.com",
  apiEndpoint: "https://njwnvk24ma.execute-api.us-east-1.amazonaws.com/prod",
  appDomain: "https://dev.blackcaphealth.com",
  region: "us-east-1",
  terminology,
};

export default config;
